import { render, staticRenderFns } from "./GSelectIdioma.vue?vue&type=template&id=3c05470c"
import script from "./GSelectIdioma.vue?vue&type=script&lang=js"
export * from "./GSelectIdioma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports